import { withPublicHOC } from '../../hoc';
import {
  PublicContentContainer,
  PublicPageHeading,
  PublicPageContent,
} from '../../components/styled';

const PublicPage = ({ privacyPolicy }) => {
  return (
    <PublicContentContainer>
      <PublicPageHeading>
        <h1>Privacy Policy</h1>
      </PublicPageHeading>
      <PublicPageContent
        className="content"
        dangerouslySetInnerHTML={{ __html: privacyPolicy }}
      ></PublicPageContent>
    </PublicContentContainer>
  );
};

export default withPublicHOC(PublicPage);
